import { useParams } from "react-router-dom";
import { ArticleTemplate } from "@/components/insights/ArticleTemplate";
import { getArticle } from "@/data/articles.data";
import NotFound from "@/pages/NotFound";

export default function InsightDetail() {
  const { slug } = useParams();
  const data = getArticle(slug);
  if (!data) return <NotFound />;
  return <ArticleTemplate data={data} />;
}
